export const environment = {
  name: 'dev',
  production: false,
  configFile: 'assets/config/config.dev.json'
};
